import axios from "axios";
import { Message } from "element-ui";
//import router from "../router";

// create an axios instance
const service = axios.create({
  // baseURL: 'https://www.easy-mock.com/mock/5b826697ddcc5d66064e7dee/chengYiXing',
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (localStorage.getItem('isLogin')&&localStorage.getItem('token')) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['token'] = localStorage.getItem('token');
    // }
    config.headers["content-type"] = "application/json;charset=UTF-8";
    const token = localStorage.getItem('token')
      ? localStorage.getItem('token')
      : '';
    config.params = {
      token: token
    };
    return config;
  },
  error => {
    // //console.log(error) // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    // if (res.code !== 0) {
    //     Message({
    //         message: res.message,
    //         type: 'error',
    //         duration: 5 * 1000
    //     })
    //     if (res.code == 100) { //会话过期
    //         localStorage.clear();
    //         router.push({ name: 'login' })
    //     }
    //     return Promise.reject('error')
    // } else {
    //     return res.data;
    // }
    if (res.error == 0) {
      return res.data;
    } else {
      Message({
        message: res.errMsg,
        type: "error",
        duration: 5 * 1000
      });
      if (res.error == 100) {
        //会话过期
        localStorage.clear();
        this.$router.push("/login");
      }
      return Promise.reject("error");
    }
  },
  error => {
    // //console.log('error' + error) // for debug
    let msg = error.message;
    if (error == "timeout of 5000ms exceeded") {
      msg = "请求时间超时";
    }
    Message({
      message: msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
